import { Button } from '@progress/kendo-vue-buttons';
/**
 * @hidden
 */

var ToggleButtonVue2 = Button;
/**
 * @hidden
 */

var ToggleButton = ToggleButtonVue2;
export { ToggleButton, ToggleButtonVue2 };